import React, { Component } from "react";
import {
  Icon,
  Input,
  Button,
  Spin,
  Alert,
  Row,
  Col,
  Divider,
  Tooltip,
  Select,
  Checkbox,
  message,
} from "antd";
import "./register.css";
import registerLogo from "./logo.png";
import F from "../../Functions";
import axios from "axios";
import Cookies from "js-cookie";
import Sidebar from "./parts/sidebar";
import { SET_EXT_USER_NOTIFICATIONS, SET_USER_FOR_BAD_PHONE_NUMBER_NOTIFICATION } from "../../utils/Api_enums";
import { EA, INVALID_REQUEST_PLEASE_CHECK_YOUR_INPUT, LSP, PLEASE_TRY_AGAIN_LATER } from "../../utils/Constants";

const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class Register extends Component {
  state = {
    loading: false,
    token: "",
    user: {
      id: "",
      first_name: "",
      last_name: "",
      visible_pass: false,
      visible_confirm_pass: false,
      password: "",
      confirm_password: "",
      timezone: "",
    },
  };
  componentDidMount = () => {
    window.document.body.classList.add("register");
    if (typeof this.props.match.params.token !== "undefined") {
      this.setState({ loading: true });
      axios
        .get("/api/token/" + this.props.match.params.token)
        .then((res) => {
          const user = res.data;
          this.setState({
            loading: false,
            token: this.props.match.params.token,
            user: {
              id: user.id,
              first_name: user.first_name,
              last_name: user.last_name,
              timezone: user.timezone,
              password: "",
              confirm_password: "",
            },
          });
        })
        .catch(() => {
          this.setState({ loading: false });
          message.error(F.translate(`Token has been expired.`));
          this.props.history.push("/login");
        });
    } else {
      this.setState({ loading: false });
      this.props.history.push("/login");
      message.error(F.translate(`No user token found.`));
    }
  };
  componentWillUnmount = () => {
    window.document.body.classList.remove("register");
  };
  updateField = (name, value) => {
    const { user } = this.state;
    user[name] = value;
    this.setState({ user });
  };
  timezone_offset = (timezone) => {
    const offsets = {
      "US/Samoa": "-11",
      "US/Hawaii": "-10",
      "US/Alaska": "-9",
      "US/Pacific": "-8",
      "US/Mountain": "-7",
      "US/Central": "-6",
      "US/Eastern": "-5",
    };
    if (typeof offsets[timezone] !== "undefined") {
      return offsets[timezone];
    } else {
      return null;
    }
  };
  submit = () => {
    const { user, token } = this.state;
    if (
      user.first_name === "" ||
      user.last_name === "" ||
      user.password === "" ||
      user.confirm_password === ""
    ) {
      message.error(F.translate(`Please fill all required fields.`));
    } else if (user.password !== user.confirm_password) {
      message.error(
        F.translate(`Confirmation password does not match the password.`)
      );
    }
    else if (user.password && !F.password_verify(user).name_complexity_equirements()) {
      message.error("Password must not include the user's first or last name.")
    }
    else if (user.password && !F.password_verify(user).complexity_equirements()) {
      message.error('Password should contain Uppercase letters, Lowercase letters, Numbers and Special characters.')
    }
    else if (user.password && !F.password_verify(user).password_length()) {
      message.error(
        F.translate(`Password should contain atleast 9 digits and not more than 20 digits.`)
      );
    }
    else {
      this.setState({ loading: true });
      axios
        .put("/api/token/" + token, {
          first_name: user.first_name,
          last_name: user.last_name,
          language: "en",
          password: user.password,
          timezone: user.timezone,
          timezone_offset: this.timezone_offset(user.timezone),
        })
        //commented since this not to be included for Dev Review month for now
        .then((res) => {
          if (res.data && res.data.user_type && (res.data.user_type == EA ||
            res.data.user_type == LSP)) {
            const userId = res.data.user_agency_assoc && res.data.user_agency_assoc[0] &&
              res.data.user_agency_assoc[0].user_id;
            if (userId) {
              return axios.post(SET_EXT_USER_NOTIFICATIONS, {
                user_id: userId,
                status: true
              });
            }
          }
        })
        .then(() => {
          this.setState({ loading: false });
          this.props.history.push("/login");
        })
        .catch((e) => {


          this.setState({ loading: false });

          if (e.response && e.response.status == 400) {
            message.error(
              F.translate(
                e.response.data.message ||
                INVALID_REQUEST_PLEASE_CHECK_YOUR_INPUT
              )
            );
          } else {
            message.error(
              F.translate(PLEASE_TRY_AGAIN_LATER)
            );
          }
        });
    }
  };

  toggleVisibility = (type) => {
    if (type === 'password')
      this.setState({ visible_pass: !this.state.visible_pass }) // NOSONAR
    else
      this.setState({ visible_confirm_pass: !this.state.visible_confirm_pass }) // NOSONAR
  }

  render() {
    const { loading, user, price, agree } = this.state;
    const updateField = this.updateField;

    return (
      <div className="register-form">
        <Row type="flex">
          <Sidebar />
          <Col md={16} span={24} className="content">
            <Spin indicator={antIcon} spinning={loading}>
              <h1>Register</h1>
              <Divider />
              <Row gutter={16}>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>First Name <span className="asteriskIcon">*</span></label>

                    <Input
                      value={user.first_name}
                      onChange={(e) =>
                        updateField("first_name", e.target.value)
                      }
                      maxLength={50}
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>Last Name <span className="asteriskIcon">*</span></label>

                    <Input
                      value={user.last_name}
                      onChange={(e) => updateField("last_name", e.target.value)}
                      maxLength={50}
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      Password <span className="asteriskIcon">*</span>

                      <div className="right">
                        <Tooltip
                          placement="bottom"
                          title={`Password must be 9-20 characters, include at least 1 Uppercase character, 1 Lowercase character, 1 Numeric digit and a Special character.`}
                          getPopupContainer={() => document.body}
                        >
                          <Icon
                            type="exclamation-circle-o"
                            style={{ color: "#1890ff" }}
                          />
                        </Tooltip>
                      </div>
                    </label>

                    <Input
                      type={this.state.visible_pass ? 'text' : 'password'}
                      value={user.password}
                      onChange={(e) => updateField("password", e.target.value)}
                      suffix={
                        <Icon
                          type={this.state.visible_pass ? 'eye-invisible' : 'eye'}
                          onClick={() => this.toggleVisibility('password')}
                          style={{ cursor: 'pointer' }}
                        />
                      }
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>Confirm Password <span className="asteriskIcon">*</span></label>

                    <Input
                      type={this.state.visible_confirm_pass ? 'text' : 'password'}
                      value={user.confirm_password}
                      onChange={(e) =>
                        updateField("confirm_password", e.target.value)
                      }
                      suffix={
                        <Icon
                          type={this.state.visible_confirm_pass ? 'eye-invisible' : 'eye'}
                          onClick={() => this.toggleVisibility('confirm_password')}
                          style={{ cursor: 'pointer' }}
                        />
                      }
                    />
                  </div>
                </Col>
                <Col md={24} span={24}>
                  <div className="inputField">
                    <label>Timezone:</label>
                    <Select
                      defaultValue={user.timezone}
                      style={{ width: "100%" }}
                      onChange={(value) => this.updateField("timezone", value)}
                    >
                      <Option value={""}>{"Select Timezone..."}</Option>
                      <Option value="US/Samoa">Samoa Time Zone (-11:00)</Option>
                      <Option value="US/Hawaii">
                        Hawaii-Aleutian Time Zone (-10:00)
                      </Option>
                      <Option value="US/Alaska">
                        Alaska Time Zone (-09:00)
                      </Option>
                      <Option value="US/Pacific">
                        Pacific Time Zone (-08:00)
                      </Option>
                      <Option value="US/Mountain">
                        Mountain Time Zone (-07:00)
                      </Option>
                      <Option value="US/Central">
                        Central Time Zone (-06:00)
                      </Option>
                      <Option value="US/Eastern">
                        Eastern Time Zone (-05:00)
                      </Option>
                    </Select>
                  </div>
                </Col>
              </Row>
              <Divider />
              <div className="right-align">
                <Button type="primary" onClick={() => this.submit()}>
                  Submit
                </Button>
              </div>
            </Spin>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/scenes/Register/register-lsp.js